const LITB_LOCAL_DOMAIN: Array<string | RegExp> = [/(?:192.168)/, /(?:localhost)/, /(?:127.0)/];
export const isLocalDevelop = (hostname: string): boolean => {
	return LITB_LOCAL_DOMAIN.some((domain) => {
		return hostname.match(domain);
	});
};
